module.exports = __webpack_public_path__ + "static/media/LINK-BNB.74cb612f.svg";